import React, { FC } from 'react';

import { FormikProps } from 'formik';
import PasswordField from '../../../../FormFields/PasswordField';
import { SignUpFormData } from '../../../../../models/auth/@types';
import Typo from '../../../../Typo';
import { getFieldError } from '../../../../FormFields/Utils';
import styles from './password.module.sass';

export interface PasswordProps {
  passwordKey: string;
  confirmPasswordKey: string;
  formikProps: FormikProps<Partial<SignUpFormData>>;
}

const Password: FC<PasswordProps> = props => {
  const { passwordKey, confirmPasswordKey, formikProps } = props;
  const errors = {
    password: getFieldError(passwordKey, formikProps),
    confirmPassword: getFieldError(confirmPasswordKey, formikProps),
  };
  return (
    <div className={styles.passwordRoot}>
      <Typo normal classes={`mb-1 is-block ${styles.fieldLabel}`}>
        Choose a password
      </Typo>
      <Typo small classes={styles.subtitle}>
        {/* Minimum 8 characters: at least one lowercase (a-z); at least one
        uppercase (A-Z); at least one digit (0-9); and at least one special
        character (e.g. ? @ # ! % & +) */}
        Minimum of 6 characters
      </Typo>
      <PasswordField
        valueKey={passwordKey}
        rootClassName={`${styles.passwordField} mb-5`}
        otherFieldProps={{
          placeholder: 'Password',
          onChange: formikProps.handleChange,
          onBlur: formikProps.handleBlur,
          value: formikProps?.values?.password,
        }}
        error={errors.password}
        hidePasswordByDefault
      />
      <PasswordField
        valueKey={confirmPasswordKey}
        rootClassName={styles.passwordField}
        otherFieldProps={{
          placeholder: 'Repeat Password',
          onChange: formikProps.handleChange,
          onBlur: formikProps.handleBlur,
          value: formikProps?.values?.confirmPassword,
        }}
        error={errors.confirmPassword}
        hidePasswordByDefault
      />
    </div>
  );
};

export default Password;
